import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchScholarshipDetails = createAsyncThunk(
  "scholarship/fetchScholarshipDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`${server}/ScholarshipStudents`, {
        headers: {
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      const students = response.data?.["body-json"]?.body?.students;
      if (students) {
        return students;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching scholarship details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const scholarshipSlice = createSlice({
  name: "scholarship",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScholarshipDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchScholarshipDetails.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchScholarshipDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default scholarshipSlice.reducer;
